<template>
  <div class="form-container">
    <div class="form-container__item">
      <RCInput
        :label="$t('stopsInfo.createStopInfo.firstName')"
        :class="emptyFields['first_name'] === true ? 'missing-field' : ''"
        :floatLabel="true"
        type="text"
        v-model="newContactInfo.first_name"
        :minlength="inputLimits.first_name.min"
        :maxlength="inputLimits.first_name.max"
      />
    </div>
    <div class="form-container__item">
      <RCInput
        :label="$t('stopsInfo.createStopInfo.lastName')"
        :class="emptyFields['last_name'] === true ? 'missing-field' : ''"
        :floatLabel="true"
        type="text"
        v-model="newContactInfo.last_name"
        :minlength="inputLimits.last_name.min"
        :maxlength="inputLimits.last_name.max"
      />
    </div>
    <div class="form-container__item form-container__item--phone">
      <InputPhone
        @changePhone="handlePhoneNumber"
        @changeFlag="handleSelectedFlag"
        :phoneValue="newContactInfo.phone"
        :emptyFields="emptyFields"
      ></InputPhone>
    </div>
    <div class="form-container__item form-container__item--email">
      <RCInput
        :label="$t('stopsInfo.createStopInfo.email')"
        :class="emptyFields['email'] === true ? 'missing-field' : ''"
        :floatLabel="true"
        class="create-contact-inputs__input-field"
        type="text"
        v-model="newContactInfo.email"
        :minlength="inputLimits.email.min"
        :maxlength="inputLimits.email.max"
      />
      <span v-show="error.email == true" class="form-container__validation">
        * {{ $t("createAccount.error.validateEmailAdress") }}
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import RCInput from "../../../../components/RCComponents/CustomRCInput.vue";
import ValidateEmptyFields from "../../../../utils/validateEmptyFields";
import InputPhone from "../../../../components/InputPhone.vue";

export default {
  /* eslint-disable no-return-assign */
  name: "CreateContactInputs",
  props: { newContactInfo: Object },
  components: {
    RCInput,
    InputPhone,
  },
  data() {
    return {
      selectedFlag: "",
      selectedContact: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      },
      emptyFields: {
        first_name: false,
        last_name: false,
        phone: false,
        email: false,
      },
      error: {
        phoneNumber: false,
        email: false,
      },
      inputLimits: {
        first_name: {
          min: 1,
          max: 23,
        },
        last_name: {
          min: 1,
          max: 23,
        },
        phone: {
          min: 7,
          max: 25,
        },
        email: {
          min: 7,
          max: 100,
        },
      },
    };
  },
  watch: {
    "selectedContact.first_name": {
      handler(newValue) {
        const result = this.replaceNumbersForLetters(newValue);
        Vue.nextTick(() => (this.selectedContact.first_name = result));
      },
    },
    "selectedContact.last_name": {
      handler(newValue) {
        const result = this.replaceNumbersForLetters(newValue);
        Vue.nextTick(() => (this.selectedContact.last_name = result));
      },
    },
  },
  created() {
    this.selectedContact = this.newContactInfo;
  },
  methods: {
    handlePhoneNumber(newPhoneNumber) {
      this.newContactInfo.phone = newPhoneNumber;
    },
    handleSelectedFlag(newFlag) {
      if (newFlag !== "") {
        this.selectedFlag = newFlag;
      }
    },
    replaceNumbersForLetters(value) {
      const result = value.toString().replace(/\d/g, "");
      return result;
    },
    validateFormfields() {
      const regexpEmail = this.validateEmails(this.selectedContact.email);
      if (regexpEmail) {
        this.error.email = false;
      } else {
        this.error.email = true;
      }
      const validatedForm = ValidateEmptyFields(this.selectedContact);
      this.resetEmptyFieldsValues();
      validatedForm.emptyFields.forEach((field) => {
        this.emptyFields[field] = true;
      });
      if (validatedForm.validation && regexpEmail) {
        this.addPrefixPhoneNumber();
        this.$emit("input", this.selectedContact);
      }
      if (validatedForm.validation && regexpEmail) {
        return validatedForm.validation;
      }
      return false;
    },
    addPrefixPhoneNumber() {
      let newCountryCode = "";
      switch (this.selectedFlag) {
        case "MEX":
          newCountryCode = "52";
          break;
        case "USA":
        case "CAN":
          newCountryCode = "1";
          break;
        default:
          newCountryCode = "1";
      }

      // Regular expression to find the prefix of the above country code.
      const regex = new RegExp(`^${this.countryCode}`);

      // Remove the previous country code from the phone number
      const currentPhone = this.selectedContact.phone.replace(regex, "");

      // Add new country code
      this.selectedContact.phone = newCountryCode + currentPhone;

      // Update the current country code
      this.countryCode = newCountryCode;
    },
    resetEmptyFieldsValues() {
      const keys = Object.keys(this.emptyFields);
      keys.forEach((key) => {
        this.emptyFields[key] = false;
      });
    },
    handleMissingStyles(value, attribute) {
      if (value) {
        this.emptyFields[attribute] = false;
      } else {
        this.emptyFields[attribute] = true;
      }
    },
    validatePhoneNumber(number) {
      let response = "";
      const firstCharacter = this.selectedContact.phone.charAt(0);
      // eslint-disable-next-line eqeqeq
      if (firstCharacter == 1) {
        if (this.selectedContact.phone) {
          if (number.length === 11) {
            response = true;
          } else {
            response = false;
          }
        }
      } else if (this.selectedContact.phone) {
        if (number.length === 10) {
          response = true;
        } else {
          response = false;
        }
        return response;
      }
      return response;
    },
    validateEmails(email) {
      // eslint-disable-next-line max-len
      const regexp = new RegExp(
        /^.*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/
      );
      if (regexp.test(email)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;

.form-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  &__item {
    &--phone {
      grid-column: span 2;
      position: relative;
      display: flex;
      flex-direction: column;
      border-radius: 7px;
      border: 1px solid $color-border-container !important;
      background: white;
    }
    &--email {
      grid-column: span 2;
      text-align: right;
    }
  }
  &__validation {
    color: red;
    font-size: 0.8rem;
    text-align: right;
  }
}

::v-deep .el-input__inner {
  border-radius: 0px !important;
}
</style>
